<template>

	<div id="app" class="layout">
		<Layout>
			<Header id="header">

				<div id="headerTop">


					<div v-if="ifLogin">

						<a @click="myClick">{{currentUserName}}:设置&nbsp;&nbsp;</a>
						<a @click="messageClick">| 消息{{messageCount}}&nbsp;&nbsp;</a>
						<a @click="userLogout">| 退出&nbsp;&nbsp;</a>
						&nbsp;&nbsp;<a href="/static/demo.zip" target="_blank"><img style="width: 40px; height: 40px; "
								:src="require('@/assets/image/other/zip.png')"> </a>


						<div>
							<!-- <Modal v-model="ifSignTemp" title="老虎签到" ok-text="立即打卡"  @on-ok="ok"   @on-cancel="cancel"> -->
							<Modal v-model="ifSignTemp" title="打卡签到" ok-text="立即打卡" cancel-text="" @on-ok="ok"
								@on-cancel="cancel">
								<div>

									<img style="text-align: center; padding-left: 28%; "
										:src="require('@/assets/image/other/sign.png')">
								</div>
							</Modal>
						</div>


					</div>
					<div v-else>
						<a @click="registClick"> 注册&nbsp;&nbsp;</a>
						<a @click="userLogin">|&nbsp;&nbsp;登录</a>
						&nbsp;&nbsp;<a href="/static/demo.zip" target="_blank"><img style="width: 40px; height: 40px; "
								:src="require('@/assets/image/other/zip.png')"> </a>
						<!-- 	<router-link to="/pictureUpload" replace>图片上传</router-link> | -->
					</div>

					<img id="quilkly" v-show="active === 1" @mouseover="showActive(2)" @mouseleave="showActive(1)"
						:src="require('./assets/image/element/quilkly1.png')">
					<img id="quilkly" v-show="active === 2" @mouseover="showActive(2)" @mouseleave="showActive(1)"
						:src="require('./assets/image/element/quilkly2.png')" @click="fuClick">



				</div>
				<img id="layout-logo" :src="require('./assets/image/logo/logo.png')">
				<Input id="search" v-model="searchValue" type="text" search placeholder="请输入搜索内容..."
					@on-enter="searchResources">
				<span slot="append">
					<Button type="primary">
						<Icon type="ios-search" @click.prevent="searchResources" />
					</Button>
				</span>
				</Input>
			</Header>
			<Layout id="hightCss">
				<Sider hide-trigger id="sider" width="300" collapsed-width="10" breakpoint="xl" collapsible
					v-model="isCollapsed">
					<div v-if="ifAdmin">
						<common-menu></common-menu>
					</div>

				</Sider>

				<Content>
					<Layout>
						<div id="oneHeader">
							<div class="titile" :style="activeStyle" style="cursor:pointer;" @click="toHome">首页</div>
							<!-- <div class="titile" :style="activeStyle" style="cursor:pointer;" @click="ruleClick">站内规则
							</div> -->
							<div class="titile" :style="activeStyle" style="cursor:pointer;" @click="registClick">用户注册
							</div>

							<span v-if="ifCommon">
								<div class="titile" :style="activeStyle" style="cursor:pointer;" @click="toDevUser">
									开发者申请</div>
							</span>
							<span v-if="ifDeveloper">

								<span v-if="!ifBz">
									<div class="titile" :style="activeStyle" style="cursor:pointer;"
										@click="toBlockUser">
										版主申请</div>
								</span>
							</span>
							<div class="titile" :style="activeStyle" style="cursor:pointer;" @click="contactUs">联系我们
							</div>
							<span v-if="ifLogin" <div class="titile" :style="activeStyle" style="cursor:pointer;"
								@click="toComplaint">投诉处理

						</div>
						</span>
						<!-- <div><a id="right" href="https://wwww.baidu.com">呆猫:https://wwww.baidu.com</a> </div> -->
	</div>
	<fire-menu></fire-menu>
	<block-menu></block-menu>
	<Content>
		<router-view></router-view>
	</Content>



	</Layout>

	</Content>
	<Sider hide-trigger id="sider" width="300" breakpoint="xxl" collapsible v-model="isCollapsed"> </Sider>

	</Layout>
	<Footer>
		<Layout>
			<div id="friendSrc" align="center">
				友情链接： SQL在线学习 | 中国风起名
			</div>
			<div align="center">
				Copyright © 2022-2032 老虎IT学习 (http://www.kittytiger.cn/) 版权所有 All Rights Reserved
			</div>
			<div align="center"  >
				备案号: 
				<a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2024065817号</a>
				公安备案：鲁公网安备37028502240658号
			</div>

		</Layout>
	</Footer>
	</Layout>
	</div>

	</div>

</template>



<script>
	import {
		logout,
		messageCount,
		pointSignAdd
	} from '@/network/index.js';
	import FireMenu from '@/components/project/firemenu/FireMenu.vue'
	import BlockMenu from '@/components/project/firemenu/BlockMenu.vue'
	import CommonMenu from '@/components/common/CommonMenu.vue'
	export default {
		name: "app",
		components: {
			FireMenu,
			BlockMenu,
			CommonMenu
		},
		props: {

		},
		data() {
			let activeColor = '#ffffff'
			let isActive = true
			return {
				activeColor,
				isActive,
				isCollapsed: false,
				ifLogin: false,
				ifDeveloper: false,
				ifBz: false,
				ifCommon: false,
				ifAdmin: false,
				ifSign: false,
				ifSignTemp: false,
				active: 1,
				signPoint: 0,
				searchValue: null,
				messageCount: '',
				currentUserName: '',

			}
		},
		created() {

			// 在页面加载时读取sessionStorage里的状态信息
			let store = sessionStorage.getItem("store");
			if (store !== null) {
				if (store !== "{\"userInfo\":null}") {
					this.$store.replaceState(
						Object.assign({}, this.$store.state, JSON.parse(store))
					);
				}
			}
			// pagehide 解决ios移动端不支持beforeunload,安卓端两个都可以用
			// 在页面刷新时将vuex里的信息保存到sessionStorage里

			window.addEventListener('pagehide', () => {
				sessionStorage.setItem('store', JSON.stringify(this.$store.state));
			});


			let ifEmpty = (JSON.stringify(this.$store.state.userInfo) == "{}" || JSON.stringify(this.$store.state
				.userInfo) == null);

			if (ifEmpty) {
				this.ifLogin = false;
			} else {

				this.ifLogin = true;

				//判断是否签到过

				this.ifSign = this.$store.state.userInfo.sign;
				this.ifSignTemp = !this.ifSign;

				let roles = this.$store.state.userInfo.roles[0];

				if (roles.includes("ROLE_BLOCKER") || roles.includes("ROLE_AUDITOR") || roles.includes("ROLE_ADMIN")) {
					this.ifAdmin = true;
				}

				if (roles == "ROLE_COMMON") {
					this.ifCommon = true;
				}

				if (roles.includes("ROLE_DEVELOPERS")) {
					this.ifDeveloper = true;
				}
				if (roles.includes("ROLE_BLOCKER")) {
					this.ifBz = true;
				}


			}

			this.currentUserName = this.$store.state.userInfo.userName;
			//查看当前用户有几条未读消息 
			messageCount().then(res => {
					this.messageCount = res.data.obj.dataCount
					if (this.messageCount == 0) {
						this.messageCount = ''
					}
				})
				.catch(error => {});
		},


		computed: {
			activeStyle() {
				return this.isActive ? {
					color: this.activeColor,
					background: '#2d8cf0',

				} : {}
			}

		},

		methods: {
			ok() {
				pointSignAdd().then(res => {
						if (res.code == '201') {
							debugger;
							this.signPoint = res.data.obj;
							this.$Message.success('恭喜签到成功!获得' + this.signPoint + "积分");
						}
					})
					.catch(error => {
						console.log(error)
					});



			},
			cancel() {
				this.$Message.success('取消签到!');
			},

			searchResources() {
				// this.$Message.success('11111!' + this.searchValue);
				this.$router.push({
					path: '/',
					query: {
						//前面的searchValue可以随便取
						searchValue: this.searchValue,
					}
				})

			},

			userLogin() {
				this.$router.push('/login')
			},

			registClick() {
				this.$router.push('/normalUserRegiser')
			},
			ruleClick() {
				this.$router.push('/ruleDes')
			},
			//查看消息列表
			messageClick() {
				this.$router.push('/messageList')
			},
			fuClick() {

				if (this.ifLogin == false) {
					this.$Message.success('请先登录在发帖!');
					this.$router.push('/login')
				} else {
					if (this.ifDeveloper == true) {
						this.$router.push('/resourceDisplay')
					} else {
						this.$Message.success('请先成为开发者在发帖!');
					}
				}

			},
			toHome() {
				this.$router.push('/')
			},


			toComplaint() {
				this.$router.push('/complaint')
			},
			contactUs() {
				this.$router.push('/contactUs')
			},

			myClick() {
				this.$router.push('/myProfile')
			},
			toDevUser() {
				this.$router.push('/toDevUser')
			},
			toBlockUser() {
				this.$router.push('/toBlockUser')
			},
			resourceDownload() {
				this.$router.push('/resourceDownload')
			},

			pointChangeShowClick() {
				this.$router.push('/pointChangeShow')
			},
			resourceDownloadShowClick() {
				this.$router.push('/resourceDownloadShow')
			},
			userLogout() {

				logout().then(res => {
					console.log('logout')

				}).catch(error => {});

				sessionStorage.clear();
				//
				this.$store.commit({
					type: 'clearState'
				})

				this.$router.push('/')
				location.reload();


			},
			showActive(index) {
				this.active = index;
			}
		}
	}
</script>
<style lang="scss">
	#friendSrc {
		left: 30%;

		font-size: 20px; //设置字体大小

		font-family: "PingFang SC";
		padding: 3px;
		//	position: absolute;
		bottom: 0;

		border-style: solid;
		border-width: 1px;
		border-color: #f0f3ff;

	}


	#fire {
		width: 50px;
		height: 50px;
		background: #ffffff;
		position: relative;
		left: 20px;

	}

	#contexHeader {
		display: flex; //水平分布
		background-color: #ffffff; //背景色
		position: relative;
		height: 50px;
	}



	#sider {
		background: #ffffff;
	}



	.ivu-layout-content {
		background: #ffffff;

	}

	//最小高度
	#hightCss {
		min-height: 777px;
	}

	.ivu-layout-sider {
		background: #ffeafd;
	}


	//<Header> 最头部logo和搜索框的样式
	#header {

		background: #ffffff;
		border-style: solid;
		border-width: 3px;
		border-color: #ffffff;
		border-bottom-color: #2d8cf0; //设置下边框颜色为黑色
	}

	//登录注册的样式
	#headerTop {
		width: 400px;
		height: 60px;
		border-radius: 3px;
		position: absolute;
		top: 2px;
		left: 65%;
	}



	//logo的样式
	#layout-logo {
		width: 200px;
		height: 56px;
		background: #ffffff;
		border-radius: 3px;
		position: absolute;
		top: 2px;
		left: 16%;
	}



	//查询框的样式
	#search {
		width: 30%;
		text-align: center;
		// position: fixed;
		position: absolute;
		height: 30px;
		background: #ffffff;
		border-radius: 5px;
		top: 15px;
		left: 33%;

	}

	//快速发帖的样式
	#quilkly {
		width: 66px;
		height: 44px;
		background: #ffffff;
		border-radius: 3px;
		position: absolute;
		top: 5px;
		left: 75%;
	}


	//------------------------------



	//---------------------------

	//导航栏 begin
	#oneHeader {
		background-color: #2d8cf0; //背景色
		display: flex; //水平分布
		position: relative;
		height: 50px;
	}

	#right {
		position: absolute;
		right: 0px;
		width: 320px;
		color: #ffffff;
		padding: 10px;
		font-size: 20px; //设置字体大小
		padding: 10px;
	}

	.titile {
		text-align: center; //等分后居中
		height: 50px; //设置高度
		font-size: 25px; //设置字体大小
		width: 150px;
		color: #ffffff;
		padding: 7px;
		font-family: "PingFang SC";

	}

	//导航栏 end
</style>
